import { Component } from '@verndale/core';
import { countUp } from '../utils/dom';

class Module extends Component {
  setupDefaults() {
    this.dom = {
      $content: this.el.querySelector('.stat-row__top-content'),
      $numbers: this.el.querySelectorAll('.stat__title'),
      $numbersSub: this.el.querySelectorAll('.stat__subtitle'),
      $subheading: this.el.querySelector('.stat-row__subheading'),
      $heading: this.el.querySelector('.stat-row__heading'),
      $copy: this.el.querySelector('.stat-row__copy'),
      $stats: this.el.querySelectorAll('.stat__content--row'),
      $grid: this.el.querySelector('.stat-row')
    };

    this.classModifier = '--in-view';
    this.doOnce = true;
  }

  constructor(el) {
    super(el);

    if (!this.el.classList.contains('stat-row--in-edition')) {
      this.createObservers();
      this.setFlex();
    }
  }

  setFlex() {
    if (this.dom.$numbers.length === 4) {
      this.dom.$grid.style = '--column-width: 2; --flex-block: block;';
    } else {
      this.dom.$grid.style = '--column-width: 3; --flex-block: flex;';
    }
  }

  createObservers() {
    const options = {
      root: null,
      rootMargin: '0px'
    };
    const observer = new IntersectionObserver(this.handleIntersect.bind(this));
    observer.observe(this.dom.$content, options);
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if ((entry.intersectionRatio > 0) & this.doOnce) {
        this.doOnce = false;

        this.dom.$heading.classList.add(`stat-row__heading${this.classModifier}`);
        this.dom.$content.classList.add(`stat-row__top-content${this.classModifier}`);
        this.dom.$subheading?.classList.add(`stat-row__subheading${this.classModifier}`);
        this.dom.$copy?.classList.add(`stat-row__copy${this.classModifier}`);

        this.dom.$numbers.forEach((element, index) => {
          element.classList.add(`stat-row__title${this.classModifier}`);
          this.dom.$stats[index].classList.add(`stat__content--row${this.classModifier}`);

          setTimeout(() => {
            countUp(element, 2000);
          }, 500);
        });
      }
    });
  }
}

export default Module;
